<template>
    <NavbarMain :first-page="true" />
    <div v-if="loading">Loading...</div>

    <div v-else>

        <BannerFirstPage :banner_image="banner_image_en" :banner_title="banner_title_en"
            :banner_button_text="banner_button_text_en" :banner_button_link="banner_button_link_en" />

    </div>


    <CookieWarningView />
    <FooterPage />
</template>

<script>
import axios from 'axios';

import BannerFirstPage from '@/components/BannerFirstPage.vue';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import CookieWarningView from './CookieWarningView.vue';

export default {
    components: {
        NavbarMain,
        BannerFirstPage,
        FooterPage,
        CookieWarningView,
    },
    data() {
        return {
            loading: true, // Add loading state

            homepageData: { items_en: [{}] },

            id_en: '', page_name_en: '',
            banner_image_en: '', banner_title_en: '', banner_button_text_en: '', banner_button_link_en: '',
        }
    },
    methods: {
        fetchData() {
            const token = process.env.VUE_APP_WEBSITE_TOKEN;
            const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

            axios.get(`${API_URL}/api/home-content`, {
                headers: {
                    'Authorization': `Token ${token}`,
                },
            })
                .then(response => {
                    this.homepageData = response.data || { items_en: [] };

                    if (this.homepageData.items_en[0]?.active === true) {
                        this.id_en = this.homepageData.items_en[0].id;
                        this.page_name_en = this.homepageData.items_en[0].page_name;

                        this.banner_image_en = this.homepageData.items_en[0].banner_image;
                        this.banner_title_en = this.homepageData.items_en[0].banner_title;
                        this.banner_button_text_en = this.homepageData.items_en[0].banner_button_text;
                        this.banner_button_link_en = this.homepageData.items_en[0].banner_button_link;
                    }

                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetchig Homepage data:', error)
                    this.loading = false;
                });
        }
    },
    created() {
        this.fetchData(); // Move data fetching to the created hook
    },
}
</script>

<style>
body {
    margin-top: 0px;
}

.columns-6-section {
    margin-left: 5%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: auto;
}

@media all and (max-width: 850px) {
    .columns-6-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}

.columns-4-section {
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    /* Center the columns horizontally */
    align-items: center;
    gap: 10px;
    padding: auto;
}

@media all and (max-width: 850px) {
    .columns-4-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}
</style>
